<template>
  <card-canvas class="developers-home" size="large" hide-back-button>
    <h2>Developer Center</h2>
    <p v-if="$screen.isTabletOrMobile($mq)">
      The Developer Center is only available on desktop sized screens.
    </p>
    <template v-else>
      <p>
        If you're a developer, you can access data from your DoneDone account in two ways.
      </p> 
      <div class="developers-home__options">
        <div>
          <h3>API</h3>
          <div class="option-image">
            <i class="ddi ddi-data-transfer" />
          </div>
          <p>
            Access and manage data from your account via GET, POST, PUT, and DELETE requests using Basic Authentication. 
          </p>
          <dd-button 
            type="flat" 
            color="orange" 
            @click="RouteAssistant.goToUrl('https://app.swaggerhub.com/apis-docs/DoneDone/DoneDone-2-Public-API', true)"
          >View API docs</dd-button>
          <clipboard-text v-if="apiKeyHydrated" :text="apiKey" />
          <div v-else class="reveal-api-key">
            <span @click="hydrateAPIKey()">Click to reveal API Key</span>
          </div>
          <a v-if="apiKeyHydrated" :href="RouteAssistant.getAPIKeyUrl($route.params.accountId)" class="just-a-link">Regenerate your API key &rarr;</a>
        </div>
        <div>
          <h3>Webhooks</h3>
          <div class="option-image">
            <i class="ddi ddi-three-blocks" />
          </div>
          <p>
            Send event data to custom endpoints when updates happen inside of DoneDone.
          </p>
          <dd-button 
            type="flat" 
            color="orange" 
            @click="RouteAssistant.goToOutboundWebhooks($router, $route.params.accountId)"
          >Configure webhooks</dd-button>
        </div>
      </div>
    </template>
  </card-canvas>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */
import CardCanvas from '@/layouts/card-canvas.vue'
import ProfileAPI from '@/api/modules/profile.api'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */

/* API */

export default defineComponent({

  components: {
    CardCanvas,
  },

  data() {
    return {
      RouteAssistant,
      isLoading: true,
      apiKey: '',
    }
  },
  head: {
    title: 'Developers',
  },

  computed: {
    apiKeyHydrated(): boolean {
      return this.apiKey !== ''
    },
  },

  methods: {
    async hydrateAPIKey() {
      try {
        const response = await ProfileAPI.get_APIKey()
        this.apiKey = response.key
      } catch (error) {
        this.$error.emit(error, true)
      }
    },
  },
})
</script>

<style lang="scss">
.developers-home {
  &__options {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 40px;
    @include flex-row-horizontal-spacing(20px);

    > div {
      position: relative;
      flex: 1;
      border-radius: 8px;
      padding: 40px 30px 30px 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border: dashed 1px $color--gray-45;

      p {
        text-align: center;
        margin-bottom: 20px;
      }

      a {
        margin-top: 10px;
        @include lettering--p-sm--no-color;
      }

      .option-image {
        position: absolute;
        top: -20px;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 50%;
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: $border--solid-medium;
        background-color: var(--color-background-header);

        .ddi {
          font-size: 20px;
          color: var(--color-text-third);
        }
      }

      .reveal-api-key {
        cursor: pointer;
        background-color: var(--color-background-secondary);
        border-radius: 20px;
        @include lettering--p-sm;
        padding: 4px 10px;
        margin-top: 20px;
      }
    }
  }
}
</style>
